import { createSelector } from 'reselect';
import precise from '../../src/modules/precise';
import salesTaxTotal from './salesTaxTotal.selector';
import registrationTotal from './registrationTotal.selector';
import titleTotal from './titleTotal.selector';

const salesTaxTotalSel = state => salesTaxTotal(state);
const titleTotalSel = state => titleTotal(state);
const registrationTotalSel = state => registrationTotal(state);

const selector = createSelector(
  [salesTaxTotalSel, titleTotalSel, registrationTotalSel],
  (sales, title, registration) => {
    return precise(Number(sales) + Number(title) + Number(registration));
  },
);

export default selector;



// WEBPACK FOOTER //
// ./src/selectors/feeCalculatorTotal.selector.js